import React, { Component } from "react";
import { Card, CardHeader, Col, Spinner } from "reactstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import { configuration } from "../appConfig";
import { connect } from "react-redux";
import Button from "reactstrap/lib/Button";
import PreDamageSVG from "../carbodyparts/PreDamageSVG";
import PreDamageDentTable from "../carbodyparts/PreDamageDentTable";
import "./twodview.css";
import moment from "moment";
import PreDamage93SVGDentTable from "../carbodyparts/PreDamage93SVGDentTable";
import PreDamage93SVG from "../carbodyparts/PreDamage93SVG";
import axios from "axios";
import PreDamage13SVGDentTable from "../carbodyparts/PreDamage13SVGDentTable";
import PreDamage13SVG from "../carbodyparts/PreDamage13SVG";
import { reportAuthorized } from "../redux/actions/reportAuthorized";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export class PreDamage extends Component {
  state = {
    words: {},
    lang: "",
    extraImageNameArr_1: [],
    extraNewImages: [],
    loading: false,
    svgLoading: false,
    showExtraImages: false,
    data: {},
    allOtherPartImages: [
      "svg_Hood", //1
      "svg_LeftFrontFender", //2
      "svg_RightFrontFender", //3
      "svg_LeftFrontDoor", //4
      "svg_RightFrontDoor", //5
      "svg_LeftBackDoor", //6
      "svg_RightBackDoor", //7
      "svg_LeftBackFender", //8
      "svg_RightBackFender", //9
      "svg_Trunk", //10
      "svg_TrunkCover", //11
      "svg_Roof", //12
      "svg_LeftRoofFrame", //13
      "svg_RightRoofFrame", //14
      "svg_SideFenderTurnSignalRepeaterLampL", //15
      "svg_FenderTrimPlateFL", //16
      "svg_DecorStickerOfRoofFrameL", //17
      "svg_SideViewMirrorL", //18
      "svg_SideMirrorRepeaterLampL", //19
      "svg_OuterUpperDoorWindowTrim_Crom_FL", //20
      "svg_UprightOuterDoorCover_PlateFL", //21
      "svg_OuterLowerDoorWindowSlotSeal_Crom_FL", //22
      "svg_SideWindowFL", //23
      "svg_DoorHandleFL", //24
      "svg_Rocker_RunningPanelFL_DecorStrip", //25
      "svg_UprightOuterDoorCover_PlateFirstOneBL", //26
      "svg_OuterUpperDoorWindowTrim_Crom_BL", //27
      "svg_UprightOuterDoorCover_PlateSecondOneBL", //28
      "svg_OuterLowerDoorWindowSlotSeal_Crom_BL", //29
      "svg_SideWindowBL", //30
      "svg_DoorHandleBL", //31
      "svg_Rocker_RunningPanelBL_DecorStrip", //32
      "svg_QuarterWindowBL", //33
      "svg_QuarterWindowTrim_Crom_BL", //34
      "svg_FuelTankDoor", //35
      "svg_FenderTrimPlateBL", //36
      "svg_TailLightOuterL", //37
      "svg_RearWindshieldDecorTrimL", //38
      "svg_FogLightL", //39
      "svg_FogLightR", //40
      "svg_HeadlightL", //41
      "svg_HeadlightR", //42
      "svg_RadiatorGrille", //43
      "svg_HoodEmblem", //44
      "svg_CoverForPlenumChamberL", //45
      "svg_CoverForPlenumChamberR", //46
      "svg_WindshieldWiperL_ArmCap", //47
      "svg_WindshieldWiperR_ArmCap", //48
      "svg_Windshield", //49
      "svg_WindshieldDecorTrimL", //50
      "svg_WindshieldDecorTrimR", //51
      "svg_RoofDripMoldingL", //52
      "svg_RoofDripMoldingR", //53
      "svg_SunRoof", //54
      "svg_RoofRailL", //55
      "svg_RoofRailR", //56
      "svg_Antenna", //57
      "svg_TrunckCover_Spoiler", //58
      "svg_HighMountStopLight", //59
      "svg_RearWindshield", //60
      "svg_WiperForRearWindshield_ArmCap", //61
      "svg_TrunkEmblem", //62
      "svg_Emblem", //63
      "svg_TailLightInnerL", //64
      "svg_TailLightInnerR", //65
      "svg_SideFenderTurnSignalRepeaterLampR", //66
      "svg_FenderTrimPlateFR", //67
      "svg_DecorStickerOfRoofFrameR", //68
      "svg_SideViewMirrorR", //69
      "svg_SideMirrorRepeaterLampR", //70
      "svg_OuterUpperDoorWindowTrim_Crom_FR", //71
      "svg_UprightOuterDoorCover_PlateFR", //72
      "svg_OuterLowerDoorWindowSlotSeal_Crom_FR", //73
      "svg_SideWindowFR", //74
      "svg_DoorHandleFR", //75
      "svg_Rocker_RunningPanelFR_DecorStrip", //76
      "svg_UprightOuterDoorCover_PlateFirstOneBR", //77
      "svg_OuterUpperDoorWindowTrim_Crom_BR", //78
      "svg_UprightOuterDoorCover_PlateSecondOneBR", //79
      "svg_OuterLowerDoorWindowSlotSeal_Crom_BR", //80
      "svg_SideWindowBR", //81
      "svg_DoorHandleBR", //82
      "svg_Rocker_RunningPanelBR_DecorStrip", //83
      "svg_QuarterWindowBR", //84
      "svg_QuarterWindowTrim_Crom_BR", //85
      "svg_FenderTrimPlateBR", //86
      "svg_TailLightOuterR", //87
      "svg_RearWindshieldDecorTrimR", //88
      "svg_FrontBumper", //89
      "svg_LeftFrontTyre", //90
      "svg_LeftBackTyre", //91
      "svg_RightFrontTyre", //92
      "svg_RightBackTyre", //93
      "svg_BackBumper", //94
    ],
    allOther13PartImages: [
      "svg_Hood",
      "svg_LeftFrontFender",
      "svg_LeftFrontDoor",
      "svg_LeftBackDoor",
      "svg_LeftBackFender",
      "svg_TrunkCover",
      "svg_RightBackFender",
      "svg_RightBackDoor",
      "svg_RightFrontDoor",
      "svg_RightFrontFender",
      "svg_Roof",
      "svg_LeftRoofFrame",
      "svg_RightRoofFrame",
    ],
    svgPartNumber: "",
    isDeleteLoading: false,
    isRotateLoading: false,
    authorized: false,
  };

  componentDidMount = async () => {
    let partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    this.getLang();
    this.getPreDamageImages();
    this.getFallbackDetails();
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      this.props.reportAuthorized({
        Authorized : r.data.Authorized,
        DATReportAuthorized : r.data.DATReportAuthorized,
        MiniReportAuthorized : r.data.MiniReportAuthorized,
        MiniReportAuthorized2 : r.data.MiniReportAuthorized2,
        FullReportAuthorized2 : r.data.FullReportAuthorized2,
        DetailedReportAuthorized : r.data.DetailedReportAuthorized,
        AmericanReportAuthorized : r.data.AmericanReportAuthorized,
      })
      this.setState({
        showExtraImages: r.data && r.data.PreDamage === 1 ? true : false,
        data: r.data,
        authorized : r.data.Authorized
      });
    });
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  backtoDashboard = () => {
    this.props.history.push("/dashboard");
    sessionStorage.setItem("isScrolled", false);
  };
  getPreDamageImages = () => {
    let partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url = `${configuration.getExtraImages}?partnerId=${partnerId}&vin=${vin}&partName=yes`;
    Axios.get(url)
      .then((res) => {
        let extraImageNameArr_1 = [];
        if (res && res.data.extraNewImages) {
          for (const key in res.data.extraNewImages) {
            if (Object.hasOwnProperty.call(res.data.extraNewImages, key)) {
              const element = res.data.extraNewImages[key];
              const partName =
                element.name &&
                element.name.split("/")[element.name.split("/").length - 1];
              extraImageNameArr_1.push(partName);
            }
          }
          this.setState({
            extraImageNameArr_1,
            extraNewImages: res.data && res.data.extraNewImages,
          });
        }
      })
      .catch((err) => {
      });
  };
  getBase644 = async (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  };
  handleDelete = (imageObj) => {
    this.setState({
      isDeleteLoading: true,
    });
    const data = new FormData();
    const url = configuration.deleteImage;
    let closeLightbox;
    data.append("id", imageObj.id)
    data.append("part_name", imageObj.part)
    data.append("vin", imageObj.vin)
    data.append("partnerId", localStorage.getItem("partnerId"));
    data.append("is_type", "web_app");
    data.append("is_extara_image", '2');
    axios
      .post(url, data)
      .then((res) => {
        this.setState(
          {
            isDeleteLoading: false,
          },
          () => {
            if (res.data.success === true) {
              this.getPreDamageImages()
              closeLightbox = false;
              Toast.fire({
                type: "success",
                title: "Image deleted successfully!",
              });
            } else {
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
            }
          }
        );
      })
      .catch((err) => {
        this.setState({
          isDeleteLoading: false,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      });
  };

  uploadExtraImagesNew = (imageSrc, captureImageName, thisevent) => {
    this.setState({
      loading: true,
    });
    const vin = localStorage.getItem("selectedFile");
    let captureDate = moment().utc(true).format(`DD-MM-YYYY hh:mm`);
    const url = configuration.uploadExtraImages;
    // const formData = new FormData();
    // formData.append("img", imageSrc);
    // formData.append("vin", vin);
    // formData.append("partnerId", localStorage.getItem("partnerId"));
    // formData.append("captureDate", captureDate);
    // formData.append(
    //   "partName",
    //   captureImageName.includes("/")
    // ? captureImageName.split("/")[1]
    // : captureImageName
    // );
    let payload = {
      img: imageSrc,
      vin: vin,
      partnerId: localStorage.getItem("partnerId"),
      partName: captureImageName.includes("/")
        ? captureImageName.split("/")[1]
        : captureImageName,
      captureDate: captureDate,
    };
    Axios.post(url, payload)
      .then((res) => {
        if (res.data.status === 200) {
          this.getPreDamageImages();
          Toast.fire({
            type: "success",
            title: this.lang("imageUploadSuccessfully"),
          });
          this.state({
            loading: false,
          });
        } else if (res.data.status === 500) {
          this.setState({
            loading: false,
          });
        } else {
          this.setState({
            loading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      })
      .finally(() => {
        thisevent.PreDamage.value = "";
      });
  };

  handlerotate = (img_name) => {
    this.setState({
      isRotateLoading: true,
    });

    let url = configuration.Rotate_image;
    const formData = new FormData();
    formData.append("img", img_name);
    formData.append("vin", localStorage.getItem("selectedFile"));
    formData.append("partnerId", localStorage.getItem("partnerId"));
    formData.append("partName", img_name.includes(".") ? img_name.split(".")[0] : img_name);
    axios
      .post(url, formData)
      .then((res) => {
        // const imageNameKey = img_name.includes(".") ? img_name.split(".")[1] : img_name;

        // let obj = {};
        // if (arrayForApplyTimeStamp.includes(imageNameKey)) {
        //   obj = {
        //     [imageNameKey]: Date.now(),
        //   };
        // }

        this.setState(
          {
            isRotateLoading: false,
            // uniqueImageSuffix: Date.now(),
            // updatedImages: { ...this.state.updatedImages, ...obj }
          },
          () => {
            if (res.data.status === 200) {
            } else {
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
            }
          }
        );
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      })
      .finally(() => {
      });
  }

  handleChangeExtraImages = (e) => {
    let partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    this.setState(
      {
        showExtraImages: e.target.checked,
      },
      async () => {
        let flag_true = this.state.showExtraImages === true ? 1 : 0;
        let payload = {
          partnerId,
          vin,
          flag: flag_true,
        };
        const url = configuration.predamageFlag;
        await Axios.post(url, payload)
          .then((res) => {
            if (res.data.status === 200) {
              if (this.state.showExtraImages === true) {
                Toast.fire({
                  type: "success",
                  title: this.lang("Image will show in full report"),
                });
              } else {
                Toast.fire({
                  type: "success",
                  title: this.lang("Image will not show in full report"),
                });
              }
            }
          })
          .catch((err) => {});
      }
    );
  };
  getFallbackDetails = async () => {
    this.setState({ svgLoading: true });
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    const res = await axios.get(url);
    if (res.data.success !== false) {
      this.setState({
        svgPartNumber: res.data.svg_part_number,
        svgLoading: false,
      });
    }
  };
  render() {
    const client = localStorage.getItem("client");
    const {authorized} = this.state
    return (
      <>
        <div className="animated fadeIn twod_view_main_wrapper">
          <Col xs="12" sm="12">
            <Card className="print_button_card mt-2">
              <CardHeader>
                <div className="container-fluid">
                  <div className="row align-items-center p-0">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt-sm-10">
                      <div className="btn-position">
                        <Button
                          className="btn-danger mr-2"
                          onClick={() => this.backtoDashboard()}
                        >
                          {this.lang("Back")}
                        </Button>
                        <small>
                          {" "}
                          {["SWISS", "US", "CANADA", "POLAND"].includes(client) ? (
                            <span>{this.lang("DashboardVIN")} : </span>
                          ) : (
                            <span>{this.lang("VIN Number")} : </span>
                          )}
                          &nbsp; {localStorage.getItem("selectedFile")}{" "}
                        </small>
                      </div>
                      {/* <strong>{this.lang("Pre Damage")}</strong> */}
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt-sm-10">
                      <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                        <small className="d-flex align-items-center">
                          <span>{this.lang("Images Show")} :</span>
                          <span className="main_switchbar_wrapper_images">
                            <label className="switch">
                              <input
                              disabled={this.state.authorized}
                                className="switch-input"
                                type="checkbox"
                                name="showExtraImages"
                                value={this.state.showExtraImages}
                                checked={this.state.showExtraImages}
                                onClick={(e) => this.handleChangeExtraImages(e)}
                              />
                              <span
                                className="switch-label"
                                data-on={this.lang("Yes")}
                                data-off={this.lang("No")}
                              ></span>
                              <span className="switch-handle"></span>
                            </label>
                          </span>
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </CardHeader>
            </Card>
            <Card className="m-0">
              {this.state.svgLoading ? (
                <div className="row us_car_svg">
                  <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                    <div className="card">
                      <div className="card-body p-0 pb-3">
                        <Spinner />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row us_car_svg">
                  <div className="col-lg-8 col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-body p-0">
                        {this.state.svgPartNumber == 2 ? (
                          // <PreDamageSVG
                          //   uploadExtraImagesNew={this.uploadExtraImagesNew}
                          //   extraImageNameArr_1={this.state.extraImageNameArr_1}
                          //   extraNewImages={this.state.extraNewImages}
                          // />
                          <div className="row car_svg_table justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12">
                              <PreDamage13SVG
                                uploadExtraImagesNew={this.uploadExtraImagesNew}
                                extraImageNameArr_1={this.state.extraImageNameArr_1}
                                extraNewImages={this.state.extraNewImages}
                                allOtherPartImages={this.state.allOther13PartImages}
                                handleDelete={this.handleDelete}
                                handlerotate={this.handlerotate}
                                isDeleteLoading={this.state.isDeleteLoading}
                                isRotateLoading={this.state.isRotateLoading}
                                authorized={this.state.authorized}
                              />
                            </div></div>
                        ) : (
                          <div className="row car_svg_table justify-content-center">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                              <PreDamage93SVG
                                uploadExtraImagesNew={this.uploadExtraImagesNew}
                                extraImageNameArr_1={this.state.extraImageNameArr_1}
                                extraNewImages={this.state.extraNewImages}
                                allOtherPartImages={this.state.allOtherPartImages}
                                handleDelete={this.handleDelete}
                                handlerotate={this.handlerotate}
                                isDeleteLoading={this.state.isDeleteLoading}
                                isRotateLoading={this.state.isRotateLoading}
                                authorized={this.state.authorized}
                                isDisableClick={false}
                              />
                            </div></div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 twod_table_view">
                    {this.state.svgPartNumber == 2 ? (
                      // <PreDamageDentTable extraNewImages={this.state.extraNewImages}/>
                      <PreDamage13SVGDentTable
                       uploadExtraImagesNew={this.uploadExtraImagesNew}
                        handleDelete={this.handleDelete}
                        handlerotate={this.handlerotate}
                        extraImageNameArr_1={this.state.extraImageNameArr_1}
                        extraNewImages={this.state.extraNewImages}
                        allOtherPartImages={this.state.allOther13PartImages}
                        loading={this.state.loading}
                        data={this.state.data}
                        isDeleteLoading={this.state.isDeleteLoading}
                        isRotateLoading={this.state.isRotateLoading}
                        authorized={this.state.authorized}
                      />
                    ) : (
                      <PreDamage93SVGDentTable
                        uploadExtraImagesNew={this.uploadExtraImagesNew}
                        handleDelete={this.handleDelete}
                        handlerotate={this.handlerotate}
                        extraImageNameArr_1={this.state.extraImageNameArr_1}
                        extraNewImages={this.state.extraNewImages}
                        allOtherPartImages={this.state.allOtherPartImages}
                        loading={this.state.loading}
                        data={this.state.data}
                        isDeleteLoading={this.state.isDeleteLoading}
                        isRotateLoading={this.state.isRotateLoading}
                        authorized={this.state.authorized}
                      />
                    )}
                  </div>
                </div>
              )}
            </Card>
          </Col>
        </div>
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  reportAuthorized: (show) => dispatch(reportAuthorized(show)),
});

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(PreDamage);
